import {
  InteractionStatus
} from "@azure/msal-browser";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { callAuthApi } from './auth/api';
import RouterSetup from './common/components/RouterSetup';
import Footer from './common/features/Footer';
import Header from './common/features/Header';
import { setUser } from './features/userprofile/userSlice';
import log from './common/components/Logger'

function App() {
  const user = useSelector((state) => state.user.data.payload);
  const currentUrl = window.location.href.split('/').pop();
  console.log(currentUrl);
  console.log("App Rendering");
  console.log(user);

  return (
    <div>
      <AuthenticatedTemplate>
        <ProtectedComponent />
        {user !== undefined && user !== null ? (
          <div className="App">
            <header className="App-header">
              <div>
                <Header />
              </div>
            </header>
            <RouterSetup />
            <div>
              <Footer />
            </div>
          </div>
        ) : (undefined)}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        {currentUrl !== "logout" ? (
          <div>
            <LoginUser />
            <p>You are not signed in! Please sign in.</p>
          </div>
        ) : (<p>You have been logged out and can now close this window.</p>)}
      </UnauthenticatedTemplate>
    </div>
  );
}

function ProtectedComponent() {
  const { instance, inProgress, accounts } = useMsal();
  const dispatch = useDispatch();
  console.log("Inside protected component");
  // const [validAuthResponse, setValidAuthResponse] = useState(false);
  console.log("In protected component");
  const ApiList = useSelector((state) => state.apiList.apiList);

  useEffect(() => {
    console.log("Insed the use effect");
    const accessTokenRequest = {
      scopes: ["user.read"],
      account: accounts[0],
      //TODO: loginHint needs to be an environment value
      //loginHint: ApiList.loginHint
    };
    console.log("inProgress: " + inProgress);
    if (inProgress === InteractionStatus.None) {
      console.log("Insed the if statement");
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
          console.log("After acquire silent token line 67");
          //     // Acquire token silent success
          let idToken = accessTokenResponse.idToken;
          let homeAccountId = accessTokenResponse.account.homeAccountId;
          localStorage.setItem("idToken", idToken);
          localStorage.setItem("homeAccountId", homeAccountId);
          //     // Call your API with token
          callAuthApi(idToken).then((response) => {
            dispatch(setUser(response.userProfile));
            log.info(`fos_ui_log: App():ProtectedComponent(): Succesful user fetch`)
          })
        })
        .catch((error) => {
          log.error(`fos_ui_log: App():ProtectedComponent(): ${error}`)
          console.log("Inside catch block");
          instance.acquireTokenRedirect(accessTokenRequest).then((response) => {
          });
        });
    }
  }, [instance, accounts, inProgress, dispatch]);

}

function LoginUser() {
  const { instance } = useMsal();
  const ApiList = useSelector((state) => state.apiList.apiList);
  
  console.log("Logging in the user");

  useEffect(() => {
    // if not page is /logout
    const loginRequest = {
      scopes: ["user.read"],
      //loginHint: ApiList.loginHint
    };

    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });

    console.log("User has been logged in");


  }, [instance]);

}

export default App;


